import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { Switch } from '@mui/material'
import { useSnackbar } from 'notistack'
import Spiner from '../../components/General/Spiner'
import SeguridadesLogic from '../../functions/logic/Seguridades'

export default function RolesBI(props) {
    const [activeTab, setActiveTab] = useState(1)
    const [codigoRol, setCodigoRol] = useState('')
    const [nombreRol, setNombreRol] = useState('')
    const [descripcionRol, setDescripcionRol] = useState('')
    const [permisosData, setPermisosData] = useState([])
    const [permisos, setPermisos] = useState({})
    const [collapsedSections, setCollapsedSections] = useState({})
    const [confirmOpen, setConfirmOpen] = useState(false)
    const { enqueueSnackbar } = useSnackbar()
    const [currentFormEvent, setCurrentFormEvent] = useState(null)
    const [spiner, setSpiner] = useState(false)
    let permisosAsignados = [];

    const [modoEdicion, setModoEdicion] = useState(false); // false por defecto = modo creación


    useEffect(() => {
        const codigoRol = localStorage.getItem("codigoRol");
        const nombreRol = localStorage.getItem("nombreRol");
        const descripcionRol = localStorage.getItem("descripcionRol");

        if (codigoRol && nombreRol && descripcionRol) {
            setCodigoRol(codigoRol);
            setNombreRol(nombreRol);
            setDescripcionRol(descripcionRol);
        } else if (props.formData.Codigo) {
            const datForm = props.formData;
            setCodigoRol(datForm["Codigo"]);
            setNombreRol(datForm["Nombre"]);
            setDescripcionRol(datForm["Descripcion"]);

            localStorage.setItem("codigoRol", datForm["Codigo"]);
            localStorage.setItem("nombreRol", datForm["Nombre"]);
            localStorage.setItem("descripcionRol", datForm["Descripcion"]);

            
            console.log("---> Rol " +datForm["Codigo"]);
            if (datForm["Codigo"] && datForm["Codigo"].length >1) {
                setModoEdicion(true); // activar modo edición
            }
        
        }

        const localStorageData = JSON.parse(localStorage.getItem('usuarioMenu')) || []
        const localStorageDataApp = JSON.parse(localStorage.getItem('appMenu')) || []
        permisosAsignados = props.formData?.listOpciones || []

        const transformedData = localStorageDataApp.map(opcion => ({
            section: opcion.descripcionOpcion,
            permisos: opcion.acciones.length > 0
                ? opcion.acciones.map(accion => ({
                    name: `${opcion.codigoOpcion}-${accion.codigoAccion}`,
                    label: accion.descripcion,
                    id: opcion.codigoOpcion,
                    codigoAccion: accion.codigoAccion
                }))
                : [{
                    name: `${opcion.codigoOpcion}`,
                    label: opcion.descripcionOpcion,
                    id: opcion.codigoOpcion
                }]
        }))

        const initialPermisos = {}
        const initialCollapsedSections = {}

        transformedData.forEach(section => {
            section.permisos.forEach(permiso => {
                const match = permisosAsignados.find(op => {
                    const matchOpcion = op.codigoOpcion === permiso.id
                    const matchAccion = op.listAcciones?.some(acc => acc.codigoAccion === permiso.codigoAccion)
                    return permiso.codigoAccion ? matchOpcion && matchAccion : matchOpcion
                })
                initialPermisos[permiso.name] = !!match
            })
            initialCollapsedSections[section.section.toLowerCase()] = true
        })

        setPermisosData(transformedData)
        setPermisos(initialPermisos)
        setCollapsedSections(initialCollapsedSections)
    }, [])

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }

    const handlePermisosChange = (permisoName) => {
        setPermisos({
            ...permisos,
            [permisoName]: !permisos[permisoName],
        })
    }

    const toggleSection = (section) => {
        setCollapsedSections({
            ...collapsedSections,
            [section]: !collapsedSections[section],
        })
    }

    const handleSave = (e) => {
        e.preventDefault()
        setCurrentFormEvent(e)
        setConfirmOpen(true)
    }

    const StyledButton = styled(Button)(({ theme }) => ({
        borderRadius: '20px',
        marginLeft: theme.spacing(4),
        padding: theme.spacing(1, 4),
    }))

    const handleConfirmSave = async () => {
        setSpiner(true)
        setConfirmOpen(false)

        if (!codigoRol || !nombreRol || !descripcionRol) {
            enqueueSnackbar("Todos los campos son obligatorios", {
                variant: 'warning',
                anchorOrigin: { vertical: 'top', horizontal: 'right' }
            })
            setSpiner(false)
            return
        }

        const usuarioCreacion = localStorage.getItem('userName')
        const usuarioModificacion = localStorage.getItem('userName')
        const usuarioFinal = props.formData ? usuarioCreacion : usuarioModificacion

        const opcionesSeleccionadas = permisosData.reduce((result, section) => {
            section.permisos.forEach(permiso => {
                const isSelected = permisos[permiso.name] // Esto determina si la opción está seleccionada
                const esActivo = isSelected ? "S" : "N" // Si está seleccionada es "S", sino "N"

                const match = permisosAsignados.find(op => {
                    const matchOpcion = op.codigoOpcion === permiso.id
                    const matchAccion = op.listAcciones?.some(acc => acc.codigoAccion === permiso.codigoAccion)
                    return permiso.codigoAccion ? matchOpcion && matchAccion : matchOpcion
                })

                result.push({
                    codigoOpcion: permiso.id,
                    esActivo,
                    [props.formData.Codigo ? 'usuarioModificacion' : 'usuarioModificacion']: usuarioFinal,
                    listAcciones: permiso.codigoAccion
                        ? [{
                            codigoAccion: permiso.codigoAccion,
                            esActivo,
                            [props.formData.Codigo ? 'usuarioModificacion' : 'usuarioCreacion']: usuarioFinal,
                        }]
                        : []
                })
            })
            return result
        }, [])

        if (opcionesSeleccionadas.length === 0) {
            enqueueSnackbar("Debe seleccionar al menos una opción", {
                variant: 'warning',
                anchorOrigin: { vertical: 'top', horizontal: 'right' }
            })
            setSpiner(false)
            return
        }

        const payload = {
            status: props.formData.Codigo ? "edit" : "load",
            codigoRol,
            nombreRol,
            descripcionRol,
            esActivo: "S",
            [props.formData.Codigo ? 'usuarioModificacion' : 'usuarioCreacion']: usuarioFinal,
            listOpciones: opcionesSeleccionadas
        }

        const resp = await SeguridadesLogic.saveEditRolesLogic(payload)
        setSpiner(false)
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: { vertical: 'top', horizontal: 'right' }
        })

        if (resp.success) {
            window.location.reload()
        }
    }


    const handleCancelSave = () => {
        setConfirmOpen(false)
    }

    return (
        <div className="container mt-4">
            <Spiner opt={spiner} />
            <div className="d-flex justify-content-center mb-3">
                <button
                    className={`btn ${activeTab === 1 ? 'btn-light' : 'btn-outline-light border'}`}
                    onClick={(e) => { e.preventDefault(); handleTabClick(1) }}>
                    1 Nuevo Rol
                </button>
                <span className="mx-2">➔</span>
                <button
                    className={`btn ${activeTab === 2 ? 'btn-light' : 'btn-outline-light border'}`}
                    onClick={(e) => { e.preventDefault(); handleTabClick(2) }}>
                    2 Permisos
                </button>
            </div>
            <div className="card">
                {activeTab === 1 && (
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Código</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código"
                                        value={codigoRol}
                                        onChange={(e) => setCodigoRol(e.target.value)}
                                        disabled={modoEdicion}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nombre</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre"
                                        value={nombreRol}
                                        onChange={(e) => setNombreRol(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Descripción</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Descripción"
                                        value={descripcionRol}
                                        onChange={(e) => setDescripcionRol(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={() => handleTabClick(2)}>Siguiente</button>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 2 && (
                    <div className="card-body">
                        <h5>Asignar Permisos</h5>
                        <p>Administrador de accesos para el rol</p>
                        {permisosData.map((section, index) => (
                            <div key={index} className="mb-3">
                                <h6 className="d-flex justify-content-between align-items-center">
                                    <span
                                        onClick={() => toggleSection(section.section.toLowerCase())}
                                        style={{ cursor: 'pointer' }}>
                                        <span className="collapse-icon">
                                            {collapsedSections[section.section.toLowerCase()] ? '-' : '+'}
                                        </span> {section.section}
                                    </span>
                                </h6>
                                {collapsedSections[section.section.toLowerCase()] && (
                                    <div className="submenu">
                                        {section.permisos.map((permiso, permisoIndex) => (
                                            <div key={permisoIndex} className="d-flex justify-content-between align-items-center">
                                                <label>{permiso.label}</label>
                                                <Switch
                                                    checked={permisos[permiso.name]}
                                                    onChange={() => handlePermisosChange(permiso.name)}
                                                    color="primary"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className="d-flex justify-content-between">
                            <button className="btn btn-secondary" onClick={() => handleTabClick(1)}>Atrás</button>
                            <a className="btn btn-primary" onClick={handleSave}>Guardar</a>
                        </div>
                    </div>
                )}
            </div>
            <Dialog open={confirmOpen} onClose={handleCancelSave}>
                <DialogTitle>Confirmar Acción</DialogTitle>
                <DialogContent>
                    <p>¿Estás seguro de que deseas guardar/editar la información?</p>
                </DialogContent>
                <DialogActions>
                    <StyledButton onClick={handleCancelSave} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
                        Cancelar
                    </StyledButton>
                    <StyledButton onClick={handleConfirmSave} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
                        Confirmar
                    </StyledButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}
